var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-page',[(_vm.content)?_c('div',[_c('b-btn',{staticClass:"px-0 mt-2",attrs:{"variant":"link","size":"lg"},on:{"click":function($event){return _vm.$router.push({
                    name: 'supportTopic',
                    params: {
                        id: _vm.topic.id,
                    },
                })}}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":"fa-light fa-chevron-left"}}),_vm._v(" "+_vm._s(_vm.topic.name)+" ")],1),_c('h5',[_vm._v(" "+_vm._s(_vm.content.title)+" ")]),_c('preserve-whitespace',{attrs:{"content":_vm.content.description}})],1):_c('div',[_c('generic-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }